<template>
  <div
    class="project-documents-add-doc-type float-right"
  >
    <button
      id="project-documents-documents-add"
      type="button"
      class="btn btn--orange"
      @click="openModal"
    >
      {{ $t('action.addFolder') }}
    </button>
    <HKLModal
      ref="docTypeModal"
      class="add-doc-type-modal"
      okBtnAction="confirm"
      @onOkClick="() => addFolders()"
      @onCloseClick="() => closeModal()"
    >
      <div>
        <p class="confirm-header">
          {{ $t('action.addFolders') }}
        </p>
        <table>
          <thead>
            <tr>
              <th colspan="2">
                {{ $t('project.docs.projectFolder') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(folderItem, index) in folderData"
              :key="index"
            >
              <td>{{ folderItem.folderName }}</td>
              <td>
                <div class="flex items-center gap-1">
                  <i
                    class="fa fa-minus cursor-pointer"
                    :class="{'disabled-minus': folderItem.amount === 0}"
                    aria-hidden="true"
                    @click="() => folderItem.amount > 0 && updateAmountByIndex(index, -1)"
                  />
                  <input
                    v-model="folderItem.amount"
                    type="text"
                    class="doctype-amount"
                    disabled
                  >
                  <i
                    class="fa fa-plus cursor-pointer"
                    aria-hidden="true"
                    @click="() => updateAmountByIndex(index, 1)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </HKLModal>
  </div>
</template>

<script>
import lodash from 'lodash'
import { computed, unref, ref, getCurrentInstance } from 'vue-demi'
import { appendFinalDocsFolders } from '@/api/tenantProjects/request'
import HKLModal from '@/controls/Modal/HKLModal'
import genRandomID from '@/utils/genRandomID'
import { useStoreGetters } from '@/store/index'
import { useFinalDocFolderListQuery } from './hook'

export default {
  components: {
    HKLModal,
  },
  setup (_, { emit }) {
    const { proxy } = getCurrentInstance()
    let returnData = {
      genRandomID,
    }
    const { finalDocumentRef } = useStoreGetters('tenantProject', ['finalDocument'])
    const useFinalDocFolderList = useFinalDocFolderListQuery()
    const { data } = useFinalDocFolderList()
    const folderList = computed(() => {
      const sectionContents = lodash.get(unref(data), 'guidelines.0.sectionContent') || []
      return lodash.orderBy(sectionContents, ['order'], ['asc'])
    })
    const folderData = ref([])
    const foldersToAdd = computed(() => {
      return lodash.filter(unref(folderData), folder => folder.amount > 0)
    })
    const initData = () => {
      folderData.value = unref(folderList).map((item) => ({
        folderName: item.value,
        amount: 0,
      }))
    }
    const openModal = () => {
      initData()
      proxy.$refs.docTypeModal.open()
    }
    const closeModal = () => {
      proxy.$refs.docTypeModal.close()
    }

    const updateAmountByIndex = (index, amount) => {
      const folderDataItem = folderData.value[index]
      if (folderDataItem) {
        folderDataItem.amount += amount
      }
    }
    const disableBtn = computed(() => {
      return unref(foldersToAdd).length === 0
    })
    const finalDocIdRef = computed(() => unref(finalDocumentRef).id)
    const addFolders = async () => {
      const newFolders = unref(foldersToAdd).map(folder => Array(folder.amount).fill({
        folderName: folder.folderName,
      })).flat()
      await appendFinalDocsFolders(
        unref(finalDocIdRef),
        newFolders,
      )
      emit('change', unref(foldersToAdd))
      closeModal()
    }
    returnData = {
      ...returnData,
      initData,
      folderList,
      folderData,
      foldersToAdd,
      updateAmountByIndex,
      disableBtn,
      addFolders,
      openModal,
      closeModal,
    }
    return returnData
  },
}
</script>
<style lang="scss" scoped>
@import '~styles/popup';

#project-documents-documents-add {
  margin: 0;
}
.doctype-amount {
  width: 50px;
}

td:has(.doctype-amount) {
  width: 70px;
}

.add-doc-type-modal {
  ::v-deep {
    .ant-modal-body {
      margin-top: 0;
    }
  }
}

</style>
